import { Box } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import axios from 'axios';
import React, { useContext, useEffect, useRef, useState } from 'react';
import moment from 'moment'
import PageHeader from '../helper/PageHeader';
import styles from '../styles';
import Loading from '../helper/Loading';
import { authContext } from "../../context/AuthContext";
import DeleteDialog from '../helper/Dialogs';
import {englishCourseId, spanishCourseId, zoomOnlyCourseId } from '../../constants/global.js'
import { SearchBarTrainingReport } from '../helper/SearchBars';
import SortedTable from '../helper/SortedTable';
import { CSVLink } from "react-csv";


const headCells = [
    { id: 'name', centered: false, sortable: true, label: 'Name' },
    { id: 'regDate', centered: true, sortable: true, label: 'Registration Date' },
    { id: 'type', centered: true, sortable: true, label: 'Training Type' },
    { id: 'username', centered: true, sortable: true, label: 'Username' },
    { id: 'company', centered: true, sortable: true, label: 'Company Name' },
    { id: 'needCEUResult', centered: true, sortable: true, label: 'Need CEUs' },
    { id: 'needTestResult', centered: true, sortable: true, label: 'Need Test' },
    { id: 'languageCourse', centered: true, sortable: true, label: 'Language/Course' },
];
const bodyCells = [
    { name: 'name', centered: false },
    { name: 'regDate', centered: true },
    { name: 'type', centered: true },
    { name: 'username', centered: true },
    { name: 'company', centered: true },
    { name: 'needCEUResult', centered: true },
    { name: 'needTestResult', centered: true },
    { name: 'languageCourse', centered: true },
];

const headers = [
    { label: "Name", key: "name" },
    { label: "Registration Date", key: "regDate" },
    { label: "Training Type", key: "type" },
    { label: "Username", key: "username" },
    { label: "Comapany Name", key: "company" },
    { label: "Need CEU", key: 'needCEUResult' },
    { label: "Need Test", key: 'needTestResult'},
    { label: "Language/Course", key: 'languageCourse'},
  ];

const AdminTrainingReport = props => {
    const { classes } = props
    const user = useContext(authContext)
  
     let csvdatatemp = [];

    const [csvdata, setCsvData] = useState([]);

    const [data, setData] = useState(null)
    const [searchData, setSearchData] = useState({
        fromDate: '',
        toDate: '',
        languages: '',
        trainingType: '',
        company:  '',
        limit: ''
    })
    const [loading, setLoading] = useState(false)
    const [deleteDialog, setDeleteDialog] = useState({open: false, user: null})
    const mounted = useRef(true)

    useEffect(() => {
        // on unmount
        return () => mounted.current = false
    }, [])

    const handleSearch = (search) => {
        setSearchData(search)
        onSearch(search)
    }

    const onSearch = (search) => {
        if(search===null) search = searchData // if this is called from delete, then delete uses the main state (searchData)
        setLoading(true)
     
        axios.get('/api/userTraining/search', {
            params: {
                courseId: search.languages ? search.languages.value : null,
                type: search.trainingType ? search.trainingType.value : null,
                fromDate : search.fromDate ? search.fromDate : null,
                toDate : search.toDate ? search.toDate : null,
                company: search.company? search.company : null,
                limit: search.limit? search.limit : null

            }
        }).then((res) => {
            console.log('response is', res.data)
            const data = res.data.trainings.map((u) => {
                u.actionsDisabled = {
                    edit: false,
                    delete: false
                }
             u.name = u['last_name']  + ", " +  u['first_name']
             u.regDate = moment(u['registerDate']).format('LLL')
             //u.lang = u.language== null ? '' : u.language.includes('ENG') ? 'English' : 'Spanish'
             u.needCEUResult = u.needCEU == null ? '' : u.needCEU === false ? 'No' : 'Yes'
             u.needTestResult = u.needTest == null ? '' : u.needTest === false ? 'No' : 'Yes'
             u.languageCourse = u.courseId == zoomOnlyCourseId ? "Zoom Course Record" : u.courseId == englishCourseId ? "English" : "Spanish"
             u.company = u.companyName === null ? '' : u.companyName

             csvdatatemp.push(u);

         //   setCsvData(csvdata.push(tempu));

                return u;
            })
            setCsvData(csvdatatemp);
            setData(data)
            setLoading(false)
        })
    }

    const closeDeleteDialog = () => {
        setDeleteDialog({open: false, user: null})
    }

    const onDelete = (event) => {
        axios.delete("/api/instructor/" + deleteDialog.user, {
            headers: {
                'Authorization': user.accessToken
            }
        }).then(response => {  
            onSearch(null)
        })

        closeDeleteDialog() // not within the axios.then in case something goes wrong
    }

    return (
        <>
            <PageHeader
                title={"Training Report"}
            />
            {/* <SearchBarCatLevelRegionFirstLast classes={classes} onSearch={handleSearch} /> */}

            <SearchBarTrainingReport classes={classes} onSearch={handleSearch} />

            <br /><br />

            {loading ? <Loading /> : // if loading display message
                data === null ? null : // if there is no data display nothing (when first loaded in)
                    data.length === 0 ?// if there is data but it is empty
                        <Box display="flex" mt={4} justifyContent="center">
                            <h1>No Data</h1>
                        </Box>
                        :
                        <>
                            {/* {originalLength > 100 && <p>{`Found too many results (${originalLength}) limiting results to 100`}</p>} */}
                            {/* <SimpleTable
                                data={data}
                                cellKey={"username"} //username because the delete and edit functions take in the username
                                tableCells={tableCells}
                            /> */}
                            {
                                console.log('csv data', csvdata)
                            }
                            <CSVLink data={csvdata} headers={headers} >Download CSV</CSVLink>
                            <SortedTable
                            data={csvdata}
                            headCells={headCells}
                            bodyCells={bodyCells}
                            defaultSortKey={"name"}
                            cellKey={"ID"}
                            />
                            <DeleteDialog
                                open={deleteDialog.open}
                                onClose={closeDeleteDialog}
                                onDelete={onDelete}
                            />
                        </>
            }
        </>
    )
}

export default withStyles(styles, { withTheme: true })(AdminTrainingReport)